import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

/** POST /v1/skus/resolve — resolve a pasted list of SKU codes (≤500). */
export function useResolveSkus() {
  return useMutation({
    mutationFn: async (codes: string[]) => {
      const { data, error } = await apiClient.POST("/v1/skus/resolve", {
        body: { codes },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
  });
}
